// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__13MCy","question":"Question_question__3puuB","description":"Question_description__1pNSc"};